<template>
  <div>
    <div class="mainWrapper">
      <MainSideBarVue />

      <div class="rightContentWrapper">
        <div class="topNav">
          <TopBarVue />
        </div>

        <div class="innerContainer">
          <div class="theHeaderWrapper">

          

            <div><i @click="$router.go(-1)" style="font-size: 20px; font-weight: bold; cursor: pointer;"
                            class="bi bi-arrow-left"></i> Tags</div>

            <div class="headerActions">
              <button class="button-6" role="button" @click="reportStore.openCreateNewTagModal">
                New Tag +
              </button>


            </div>
          </div>

          <div class="searchBarWrapper" v-if="reportStore.tags.length > 0">
            <input v-model="searchQuery" type="text" class="form-control theBar" placeholder="Search..." />
          </div>

          <div v-if="reportStore.tags.length > 0">
            <div class="tableWrapper">
              <table class="table table-hover my-custom-table">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col"></th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(tag, index) in filteredTags" :key="index">

                    <td style="width: 300px">{{ tag.name }}</td>


                    <td>

                      <div class="iconsRow">

                        <i @click="reportStore.openUpdateTagModal(tag)" class="bi bi-pencil theActionIcon"
                          style="margin-right: 20px;"></i>

                        <i @click="reportStore.openDeleteTagModal(tag)"
                        class="bi bi-trash theActionIcon"></i>
                      </div>



                    </td>
                  </tr>
                </tbody>
              </table>


            </div>

          </div>

          <div v-else>
            No tags created yet.
          </div>

        </div>
      </div>
    </div>


    <div v-if="reportStore.showCreateNewTagModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px">
            <b>New Tag</b>
          </div>

          <div>
            <i @click="reportStore.closeCreateNewTagModal" class="bi bi-x-lg"
              style="font-size: 20px; cursor: pointer"></i>
          </div>
        </div>


        <div class="modal-content">

          <form @submit.prevent="reportStore.createNewTag">
            <div class="mb-3">
              <label class="form-label" style="float: left"><b>Name</b></label>
              <input v-model="reportStore.tagFormData.name" type="text" class="form-control inputStyle"
                placeholder="Name" required />
            </div>

            <div>
              <button type="submit" class="btn btn-dark createBTN">
                <b>Create</b>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="reportStore.showUpdateTagModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px">
            <b>Edit Tag</b>
          </div>

          <div>
            <i @click="reportStore.closeUpdateTagModal" class="bi bi-x-lg" style="font-size: 20px; cursor: pointer"></i>
          </div>
        </div>


        <div class="modal-content">



          <form @submit.prevent="reportStore.updateTag">
            <div class="mb-3">
              <label class="form-label" style="float: left"><b>Name</b></label>
              <input v-model="reportStore.currentTag.name" type="text" class="form-control inputStyle"
                placeholder="Name" required />
            </div>

            <div>
              <button type="submit" class="btn btn-dark createBTN">
                <b>Update</b>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>


    <div v-if="reportStore.showDeleteTagModal" class="modal-overlay">
      <div class="modal-box" style="width: 550px">
        <div class="model-box-header">
          <div style="font-size: 17px; text-align: left">
            <b>Are you sure you want to delete this tag?</b>
          </div>

          <div>
            <i @click="reportStore.closeDeleteTagModal" class="bi bi-x-lg" style="font-size: 20px; cursor: pointer"></i>
          </div>
        </div>

        <div class="modal-content" style="text-align: left" v-if="reportStore.currentTag && reportStore.currentTag.name">


 

          <p>
            <b style="color: red">Very Important Note:</b> Deleting <b>{{ reportStore.currentTag.name }}</b> tag will remove it from all toolbox talks where it is currently assigned. <b>This action cannot be undone.</b>
          </p>

          <div>
            <button @click="reportStore.deleteTag" type="button" class="btn btn-danger createBTN">
              <b>Yes, Delete!</b>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import MainSideBarVue from "@/components/MainSideBar";
import TopBarVue from "@/components/TopBar.vue";
import { onMounted, ref, computed } from "vue";
import { useReportStore } from "@/stores/ReportsStore";


const reportStore = useReportStore();

const searchQuery = ref('');


const filteredTags = computed(() => {

    return reportStore.tags
        .filter(tag => tag.name.toLowerCase().includes(searchQuery.value.toLowerCase()))

});

onMounted(() => {

  reportStore.fetchAllTags()

});
</script>

<style scoped>
.mainWrapper {
  /* background-color: aliceblue; */
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.rightContentWrapper {
  /* overflow-y: auto; */
  width: 83%;
  display: flex;
  flex-direction: column;
}

.contentContainer {
  /* overflow-y: auto; */
  background-color: rgb(208, 28, 55);
  /* margin: 30px; */
  margin-top: 100px;
}

.rightColumns {
  /* display: flex;
  flex-direction: column; */
}

.topNav {
  background-color: blue;
}

.innerContainer {
  /* margin-top: 200px; */
  /* background-color: blueviolet; */
  overflow-y: auto;
  padding-top: 30px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 100px;
}

.searchBarWrapper {
  margin-top: 15px;
  width: 100%;
  padding-bottom: 20px;
  /* background-color: rgb(22, 166, 37); */
}

.theBar {
  width: 350px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 10px;
}

.button-6 {
  align-items: center;
  /* background-color: #FFFFFF; */
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  display: inline-flex;
  font-family: system-ui, -apple-system, system-ui, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
  line-height: 1.25;
  margin: 0;
  min-height: 3rem;
  padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
  position: relative;
  text-decoration: none;
  transition: all 250ms;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  width: auto;
}

.button-6:hover,
.button-6:focus {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  color: rgba(0, 0, 0, 0.65);
}

.button-6:hover {
  transform: translateY(-1px);
}

.button-6:active {
  background-color: #f0f0f1;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
  color: rgba(0, 0, 0, 0.65);
  transform: translateY(0);
}

.tableWrapper {
  margin-top: 20px;
  /* background-color: aqua; */
  width: 100%;
}

.my-custom-table tbody tr td {
  padding-top: 20px;
  /* Adjust the value as needed */
  padding-bottom: 20px;
  /* Adjust the value as needed */
}

.my-custom-table th {
  padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
  text-align: left;
  /* Aligns text to the left */
  padding-left: 20px;
  padding-right: 20px;
}

.campName {
  text-decoration: none;
  color: inherit;
}

.campName:hover {
  color: rgb(10, 159, 92);
  cursor: pointer;
  text-decoration: none;
}

.iconsRow {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.theActionIcon {
  font-weight: bolder;
  font-size: 18px;
  color: rgb(5, 2, 2);
  cursor: pointer;
}

.theActionIcon:hover {
  cursor: pointer;
  color: rgb(30, 158, 30);
  scale: 1.3;
  transition: 1s;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  z-index: 999;
  /* Ensure the modal is on top */
}

/* Styles for the modal box */
.modal-box {
  background-color: white;
  width: 1100px;
  padding: 20px;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
  text-align: center;
}

.model-box-header {
  display: flex;
  justify-content: space-between;
  /* background-color: antiquewhite; */
  height: 40px;
  margin-bottom: 15px;
}

.form-control {
  background-color: rgb(243, 246, 246);
}

.createBTN {
  width: 100%;
  margin-top: 20px;
}

.noTeamBox {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  width: 100%;
}

.noMatchBox {
  background-color: red;
  width: 100%;
}

.loadMoreBtn {
  background-color: black;
  border-radius: 10px;
}

.inviteInput {
  width: 500px;
  font-size: 13px;
  cursor: pointer;
}

.iconDrop {
  cursor: pointer;
}

.theHeaderWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  /* background-color: aqua; */
}

.headerActions {
  display: flex;
  align-items: center;
  gap: 31px;
}

.dropdown-item {
  font-size: 13px;
}

.dropdown-item:hover,
.dropdown-item:focus {
  background-color: #f2f2f2;
  color: #000;
}

.dropdown-item:active,
.dropdown-item.active {
  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  color: #000;
}

.deletion-logs-container {
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

.deletion-logs-container table {
  margin-bottom: 0;
}

.deletion-logs-container thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.theInputSwitch {
  font-size: 20px;
  cursor: pointer;
  color: red;
}

.form-check-input:checked {
  background-color: #d84617;
  border-color: black;
  border-width: 2px;
}
</style>
